







import Vue from "vue";
import { Component } from "vue-property-decorator";
import { On } from "@rocketbase/vue-extra-decorators";

@Component({
  components: {}
})
export default class App extends Vue {
  @On("hook:mounted")
  private onMounted() {
    this.$auth.$skeletonKey.on("logout", this.onLogout);
    this.$auth.$skeletonKey.on("login", this.onLogin);
  }

  private async onLogout() {
    await this.$router.push("/auth/login");
  }

  private async onLogin() {
    await this.$router.replace("/");
  }
}
